import Decimal from 'decimal.js';
import { omit } from 'ramda';

import { DTRRule, DTRRuleConverted } from '../../types';

export const convertValueForSave = (formValue: DTRRuleConverted): DTRRule => {
  const convertedVariables = formValue.variables.map((value) => {
    const selectedRule = formValue.rules[value.ruleVariableName].value;
    return {
      ...value,
      value:
        typeof selectedRule === 'number'
          ? new Decimal(selectedRule).toDecimalPlaces(2).toNumber()
          : formValue.rules[value.ruleVariableName].value
      // copy back from rules
    };
  });

  return omit(['rules'], {
    ...formValue,
    variables: convertedVariables
  });
};
